/**
 * Store an entry while capping insertion-order retention. Rewriting an
 * existing key moves it to the newest position.
 */
export function setBoundedMapEntry<K, V>(
  map: Map<K, V>,
  key: K,
  value: V,
  maxEntries: number,
): void {
  if (maxEntries <= 0) {
    throw new Error('maxEntries must be greater than zero');
  }

  map.delete(key);
  map.set(key, value);

  while (map.size > maxEntries) {
    const oldestKey = map.keys().next().value as K;
    map.delete(oldestKey);
  }
}
